<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">设置告警列表</div>
      <div class="page-header-btn">
        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="primary" @click="add">添加</el-button>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getShipListLoading"
                   @click="getAlarmList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <el-table :data="alarmList" border style="width: 100%;font-size: 12px;">
      <el-table-column prop="deviceName" label="摄像头名称" align="center" />
      <el-table-column prop="alarmTypeName" label="告警类型" align="center" />
      <el-table-column prop="alarmLevelName" label="告警等级" align="center" />
      <el-table-column prop="alarmDescription" label="告警描述" align="center"/>
      <el-table-column prop="createTime" label="创建时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.createTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="更新时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.updateTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button-group>
            <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="edit(row)">修改</el-button>
            <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <alarmEdit ref="alarmEdit" ></alarmEdit>
  </div>
</template>

<script>
import alarmEdit from "./dialog/alarmEdit";

export default {
  name: "alarmManage",
  components: {
    alarmEdit
  },
  data() {
    return {
      alarmList: [], //公司列表
      currentPage: 1,
      count: 15,
      total: 0,
      getShipListLoading: false,
    }
  },
  created() {
    this.getAlarmList()
  },
  methods:{
    getAlarmList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/warning/list`,params: {
          page: this.currentPage,
          count: this.count
        }}).then(function (res) {
        that.alarmList = res.data.data.list;
        that.total = res.data.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getAlarmList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getAlarmList();
    },
    add(){
      this.$refs.alarmEdit.openDialog(null, this.getAlarmList)
    },
    edit(row) {
      this.$refs.alarmEdit.openDialog(row, this.getAlarmList)
    },
    del(row) {
      let that = this;
      this.$confirm('确认删除此设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getShipListLoading = true;
        this.$axios({ method: 'post', url:`/api/warning/delete`, params: {id: row.id} }).then( res => {
          if (res.data.code === 200){
            that.$message.success("删除成功！")
            this.getAlarmList()
          }else {
            that.$message.error(res.data.msg)
          }
          this.getShipListLoading = false;
        })
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/alarmManage.vue